import * as React from "react";
import { TextInput } from "soprasteria-ui-library";
import { formatOrganisationNumber } from "../../../helpers/PersonalSecurityNumberAndOrganisationNumberHelper";
import { IOrganisation } from "../../../models/IOrganisation";
import { ICounterPart } from "../../../models/ICounterPart";
import { ISector } from "../../../models/ISector";
import { OrganisationApi } from "../../../api/OrganisationApi";
import { useAuth } from "../../../App";
import { PostalAddressInformation } from "../../../components/PostalAddress/PostalAddressInformation";

interface IProps {
    organisation: IOrganisation;
}

export const OrganisationInformation: React.FunctionComponent<IProps> = ({ organisation }) => {
    const auth = useAuth();
    const api = new OrganisationApi(auth);
    const [sectors, setSectors] = React.useState<ISector[]>([]);
    const [counterParts, setCounterParts] = React.useState<ICounterPart[]>([]);

    React.useEffect(() => {
        if (sectors.length === 0) {
            loadSectors();
        }
        if (counterParts.length === 0) {
            loadCounterParts();
        }
    }, [organisation]);

    const loadSectors = () => {
        api.getSectors((data) => { setSectors(data) }, undefined, undefined);
    }

    const loadCounterParts = () => {
        api.getCounterParts((data) => { setCounterParts(data) }, undefined, undefined);
    }

    const getCounterPartName = (counterPartId: number): string => {
        if (counterParts.length > 0) {
            const selectedCounterPart = counterParts.find(cp => cp.counterPartId === counterPartId);
            return selectedCounterPart!.counterPartName;
        } else { return ""; }
    }

    const getSectorName = (sectorId: number): string => {
        if (sectors.length > 0) {
            const selectedSector = sectors.find(s => s.sectorId === sectorId);
            return selectedSector!.sectorName;
        } else { return ""; }
    }

    return (
        <>
            <div className="col-6">
                <TextInput label="Vårdgivare" name="readonly" defaultValue={organisation.name} readonly inlineLabel />
                <TextInput label="Organisationsnummer" name="readonly" defaultValue={formatOrganisationNumber(organisation.organisationNumber)} readonly inlineLabel />
                <TextInput label="Motpart" name="readonly" defaultValue={getCounterPartName(organisation.counterPartId)} readonly inlineLabel />
                <TextInput label="Leverantörsnummer" name="readonly" defaultValue={organisation.raindanceSupplierNumber} readonly inlineLabel />
            </div>
            <div className="col-6">
                <TextInput labelCol={5} inputCol={7} label="HSA-ID Vårdgivare" name="readonly" defaultValue={organisation.hsaId} readonly inlineLabel />
                <TextInput labelCol={5} inputCol={7} label="Sektor" name="readonly" defaultValue={getSectorName(organisation.sectorId)} readonly inlineLabel />
                <TextInput labelCol={5} inputCol={7} label="Bankgiro/Postgiro" name="readonly" defaultValue={organisation.accountNumber ?? "-"} readonly inlineLabel />
                <TextInput labelCol={5} inputCol={7} label="Personuppgiftsbiträdesavtal godkänt av" name="readonly" defaultValue={organisation.gdprAcceptedByName ?? "-"} readonly inlineLabel />
            </div>
            <div className="col-12">
                <hr />
                <h4>Bolagsadress</h4>
            </div>
            <PostalAddressInformation address={organisation.contractAddressAddress}
                zipCode={organisation.contractAddressZipCode}
                city={organisation.contractAddressCity}
                phoneNumber={organisation.contractAddressPhoneNumber}
                alternativePhoneNumber={organisation.contractAddressAlternativePhoneNumber}
                emailAddress={organisation.contractAddressEmailAddress} />
        </>
    )
}